// Keep navigation behavior aligned with the phone media queries in the app and authoring styles.
export const compactNavigationQuery =
  "(max-width: 720px), (hover: none) and (pointer: coarse) and (max-device-width: 600px), (hover: none) and (pointer: coarse) and (max-device-height: 600px)";
